import { render, staticRenderFns } from "./InternetLiveBoxBlock.vue?vue&type=template&id=45579f93&"
import script from "./InternetLiveBoxBlock.vue?vue&type=script&lang=ts&"
export * from "./InternetLiveBoxBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45579f93')) {
      api.createRecord('45579f93', component.options)
    } else {
      api.reload('45579f93', component.options)
    }
    module.hot.accept("./InternetLiveBoxBlock.vue?vue&type=template&id=45579f93&", function () {
      api.rerender('45579f93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/broadband/demands/ordering/components/InternetLiveBoxBlock.vue"
export default component.exports